import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  root: {
    minWidth: 'auto',
    padding: '4px 16px',
    fontSize: 15,
    fontFamily: 'NeoSansStd',

    background: '#fff',
    borderRadius: 29,
    color: theme.custom.lightBlue,
    transition: '.15s linear',

    '&:hover': {
      background: '#fff',
      color: '#0A8DC7',
    },

    '&.Mui-disabled': {
      background: '#91A0B0',
      color: '#2B5D92',

      '&:hover': {
        background: '#91A0B0',
      },
    },
  },
  startIcon: {
    marginLeft: 0,
    '& .MuiSvgIcon-root': {
      fontSize: 20,
    },
  },
  endIcon: {
    marginRight: 0,
    '& .MuiSvgIcon-root': {
      fontSize: 20,
    },
  },
}));
